import { Typography, Box, useTheme, Stack, IconButton, Dialog, DialogContent, Button, DialogTitle,DialogContentText,DialogActions} from "@mui/material";
import { tokens } from "../../theme";
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getSignImages,updateSignImage} from "../../slices/sign_image";
import { setMessage , clearMessage} from "../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
import React, { useState, useEffect,useMemo } from 'react';
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import SignService from "../../services/sign.service"
import ImageEditor from "../../components/imageEditor/Editor";
import BrokenImageIcon from '@mui/icons-material/BrokenImage';


const SignImages = (props) => {

  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const signId = props.sign.id;
  const sign = props.sign;
     
  const callBack = props.commandCallBack

  const dispatch = useDispatch();

  const getImageHeader = (image) =>{

    const header = image.split("~",1);
    const myArray = header[0].split(",");

    let imageHeader = {
      frames: 1,
      duration: 1,
    }

    return imageHeader;

  }


  const SignImages = useSelector((state) => state.signImage);

  const SignImagesData = SignImages.data.list.filter(image => image.active == true).map(image => {
    
    let newImage = {};
    let imageHeader = getImageHeader(image.image)

    Object.assign(newImage,image)
    newImage.frames = imageHeader.frames
    newImage.duration = imageHeader.duration

    return newImage;

    })

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [refreshTracker , setRefreshTracker] = React.useState(0);

  const sendSignImageCommand = async ( id, imageID) => {

    try {
      const commandId = await SignService.setSignImage(id,imageID)
      .then((response => {
          callBack(response.commandId) 
        }))

    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch(setMessage(message));
  }
  ;}



  useEffect(() => {
    
    const search = {
      page,
      pageSize,
      signId: signId,
      active: true
    }

    dispatch(getSignImages({search}));

  }, [page,pageSize,props.sign,refreshTracker]);

  const [editOpen, setEditOpen] = React.useState(false);
  const [imageToDelete, setimageToDelete] = React.useState(null);

  const handleClose = (doUpdate) => {
    setEditOpen(false);

    if(doUpdate == true){
      setPage(0);
      setRefreshTracker(refreshTracker + 1);
    }
  };

  const doDelete = () => {
    dispatch(clearMessage());

    const image = {
      id: imageToDelete,
      active: false,
    };

    dispatch(updateSignImage({image}));
    setOpenConfirmDelete(false);
    
  }
  
  const columns = [
    { 
      field: "id", 
      headerName: "ID" ,
      hide: true,
    },
    { 
      field: "preview", 
      headerName: "Image" ,
      width: 100,
      renderCell: ({row: {lastDisplayed}}) => {

        return (
          <BrokenImageIcon/>
        )
      }

    },
    { 
      field: "name", 
      headerName: "Name" ,
      flex: 2,
    },
    { 
      field: "frames", 
      headerName: "Frames" ,
      width: 75,
      minWidth: 75,
    },
    { 
      field: "duration", 
      headerName: "Duration" ,
      width: 75,
      minWidth: 75,
    },
    { 
      field: "displayedTimes", 
      headerName: "Used" ,
      width: 75,
      minWidth: 75,
    },
    
    {
      field: "lastDisplayed",
      headerName: "Last Sent to Sign",
      width: 150,
      minWidth: 150,
      renderCell: ({row: {lastDisplayed}}) => {

        return (
          <NiceDate>{lastDisplayed}</NiceDate>
        )
      }
    },
    {
      headerName: "Actions",
      field:"",
      width: 150,
      minWidth: 150,
      type:"actions",
      disableClickEventBubbling: true,

      
      renderCell: (params) => {

          const handleSend = (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const imageID = currentRow.id;

            sendSignImageCommand(signId,imageID)

          };

          const handleDelete = (e) => {
            e.stopPropagation();
            const currentRow = params.row;
            const imageID = currentRow.id;

            setimageToDelete(imageID);

            setOpenConfirmDelete(true);
          };

          const handleEdit= (e) => {
            e.stopPropagation();
            dispatch(clearMessage());
            const currentRow = params.row;
            const imageID = currentRow.id;

            setSelectedImage(currentRow);
            setEditOpen(true);

          };

          

          return (
            
            <Stack key={"STACK-" + params.row.id}  direction="row" spacing={1}>

              
              <IconButton key={"SEND-" + params.row.id}  aria-label="send" onClick={handleSend}>
                <ForwardToInboxOutlinedIcon fontSize="small" />
              </IconButton>

              <IconButton key={"EDIT-" + params.row.id} aria-label="delete" onClick={handleEdit}>
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton key={"DELETE-" + params.row.id} aria-label="delete" onClick={handleDelete}>
                <DeleteIcon fontSize="small" />
              </IconButton>

            </Stack>
          );
      },
    },

  ];

  const [openConfirmDelete, setOpenConfirmDelete] = React.useState(false);

  const handleCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
  };



  return (
    <>

    <Dialog
      open={openConfirmDelete}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Really delete Image?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This action will permentaly remove the image from your sign.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmDelete} autoFocus>No</Button>
        <Button onClick={doDelete} >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
      
    <Dialog open={editOpen} fullScreen>
        
        <DialogContent>
          <ImageEditor image = {selectedImage} closer = {handleClose} sign = {sign} sender = {sendSignImageCommand}/>
        </DialogContent>

      </Dialog>

    <Box>

      <Box display = "flex" justifyContent="flex-end" >
        <Button 
          color="secondary" 
          variant="contained" 
          onClick={() => {
            setSelectedImage(null);
            setEditOpen(true);
          }}
        >
          Create new image
        </Button>
      </Box>

      <Box
        mt = "20px"
        height="40vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

        <DataGrid  experimentalFeatures={{newEditingApi: true }}
            rows={SignImagesData} 
            columns={columns} 
            pageSize={pageSize}
            page={SignImages.data.page}
            rowsPerPageOptions={[5, 10,25,50,100]}
            paginationMode="server"
            rowCount={SignImages.data.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          />    

      </Box>

      
    </Box>
    </>
    
  );
};

export default SignImages;
